import { Td, Tfoot, Tr } from '@ff-it/ui';
import { useTable } from 'components/ControlledTable';
import { TitleContainer } from 'components/TitleContainer';
import { ReactElement } from 'react';
import { sepFormat } from 'utilities';

export function ListTotalsFooter({ before, after }: { before: number; after: number }): ReactElement | null {
  const { data } = useTable();
  if (!data) {
    return null;
  }
  const { sub_total, total }: { sub_total: string; total: string } = data.totals;

  return (
    <Tfoot>
      <Tr>
        {/* alinged to cols */}
        <Td colSpan={before} textAlign="right" fontSize="xs">
          Total (all pages)
        </Td>
        <Td textAlign="right" fontWeight="bold" className="py-0">
          <TitleContainer title={sepFormat(total)} subtitle={sepFormat(sub_total)} />
        </Td>
        <Td colSpan={after} />
      </Tr>
    </Tfoot>
  );
}
